import {InfuraType} from "../redux/globalReducers";
import {BigNumber} from "ethers";

export function zoraAuctionCreateBid(infura: InfuraType, auctionId: number, amount: BigNumber, account: string) {
    return infura.zoraAuctionContract.populateTransaction.createBid(auctionId, amount, {
        from: account,
        value: amount
    });
}
